import { injectable } from 'inversify';
import { Vue } from 'vue-property-decorator';
import * as Api from "@/app/interaction/api";
import { appendElement, queryElements } from '@/app/shared/utils/content-utils';
import QuizComponent from '@/app/quiz/components/quiz-component.vue';

@injectable()
export class IncludeQuizHandler implements Api.IncludeComponentsHandlerInterface {

  public async includeComponents($parsedContent: any): Promise<Vue[]> {
    const quizElements: any = queryElements('.quiz.component', $parsedContent);
    if (quizElements === null) {
      return [];
    }

    let components = []
    for (const quizElement of quizElements) {
      const $quizElement: any = $(quizElement);
      const quizId: string|undefined = $quizElement.attr('data-quiz-id');
      if (!quizId) {
        continue;
      }

      const component = await this.includeComponent(quizId);
      components.push(component)
    }

    return components
  }

  private async includeComponent(quizId: string): Promise<Vue> {
    
    const component: QuizComponent = new QuizComponent({
      propsData: {
        quizId: quizId
      }
    });
    component.$mount();

    const selector: string = `[data-quiz-id="${quizId}"]`;
    appendElement(selector, component.$el);

    return component
  }
}
